import React, { useCallback, useEffect, useState } from "react"

const Accessibility = (props) => {
    const { isMobile } = props;
    let [fontSize, setFontSize] = useState(0)
    let [open, setOpen] = useState(false)

    const onPlus = () =>{
        if(fontSize <= 1){
            setFontSize(fontSize + 1)
        }else{
            alert("Cannot increase the font size more than this.")
        }
    }

    const onMinus = () => {
        if(fontSize >= -1){
            setFontSize(fontSize - 1)
        }else{
            alert("Cannot reduce the font size more than this.")
        }
    }

    const onReset = () => {
        setFontSize(0)
    }

    const onHighContrast = () => {
        const body = document.getElementsByTagName('body')[0];
        body.className += "body_contrast1 ";
    }

    const onNormalContrast = () => {
        const body = document.getElementsByTagName('body')[0];
        body.className = "";
    }

    useEffect(() => {
        if (fontSize <= 2 && fontSize >= -2) {
            let html = document.querySelector("html");
            html.style.fontSize = `${100 + fontSize * 10}%`
        }
       
    }, [fontSize])

    const togglePopup = useCallback(() => {
        setOpen(!open)
    },[open])

    return (
        <>
        <a href="#" className={`setting_btn ${isMobile ? 'nav-link' : ''}`} onClick={togglePopup}>
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.13"
            height="20.895"
            viewBox="0 0 18.13 20.895"
            >
            <g
                id="Group_900"
                data-name="Group 900"
                transform="translate(-1.337 0.5)"
            >
                <circle
                id="Ellipse_16"
                data-name="Ellipse 16"
                cx="2.082"
                cy="2.082"
                r="2.082"
                transform="translate(5.903 0)"
                fill="none"
                stroke="#024594"
                strokeMiterlimit="10"
                strokeWidth="1"
                />
                <path
                id="Path_1863"
                data-name="Path 1863"
                d="M19.463,15.488a1.33,1.33,0,0,0-1.838,0l-.33.331L14.747,13.27a2.07,2.07,0,0,0-1.472-.609H10.634a.417.417,0,0,1-.416-.416V9.919l.954.954a.423.423,0,0,0,.346.119l2.457-.307a1.283,1.283,0,0,0,1.109-1.456,1.292,1.292,0,0,0-1.475-1.085l-1.283.208L10.438,6.465A1.593,1.593,0,0,0,7.719,7.589v5.487A2.084,2.084,0,0,0,9.8,15.158h3.3l3.381,3.381a1.25,1.25,0,0,0,1.767,0l1.213-1.214A1.3,1.3,0,0,0,19.463,15.488Z"
                transform="translate(-0.985 -1.004)"
                fill="none"
                stroke="#024594"
                strokeMiterlimit="10"
                strokeWidth="1"
                />
                <path
                id="Path_1864"
                data-name="Path 1864"
                d="M6.97,21.89a5.13,5.13,0,0,1-1.711-9.967.046.046,0,0,1,.017,0,.049.049,0,0,1,.015.1,5.032,5.032,0,1,0,6.554,5.973.05.05,0,0,1,.047-.037.105.105,0,0,1,.022,0,.051.051,0,0,1,.027.059A5.123,5.123,0,0,1,6.97,21.89Z"
                transform="translate(0 -1.995)"
                fill="none"
                stroke="#024594"
                strokeMiterlimit="10"
                strokeWidth="1"
                />
            </g>
            </svg>
            <span className={isMobile ? 'ml-2' : ''}>
                Accessibility
            </span>
        </a>
        <div className={`setting_wrap ${open ? 'd-block' : 'd-none'}`}>
            <div className="setting_body">
            <ul>
                <li>Font size</li>
                <li className="mb-2">
                <a
                    href="javascript:;"
                    onClick={onPlus}
                    className="font_plus"
                >
                    A+
                </a>
                |{" "}
                <a
                    href="javascript:;"
                    onClick={onReset}
                    className="font_reset"
                >
                    Reset &nbsp;
                </a>
                |{" "}
                <a
                    href="javascript:;"
                    onClick={onMinus}
                    className="font_minus"
                >
                    A-
                </a>{" "}
                </li>
                <li>Contrast</li>
                <li>
                <a
                    href="javascript:;"
                    onClick={onHighContrast}
                    className="link_contrast1"
                >
                    High Contrast &nbsp;
                </a>
                |{" "}
                <a
                    href="javascript:;"
                    onClick={onNormalContrast}
                    className="link_contrast_reset"
                >
                    Reset
                </a>
                </li>
            </ul>
            </div>
        </div>       
        </>
    )
}

export default Accessibility
